import { Component, OnInit, HostListener, Input, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { first } from "rxjs/operators";
import { AlertService, ConnectionService } from "../_services";

@Component({
  selector: 'app-connname',
  templateUrl: './coonection.name.html'
})
export class ConnectionNameComponent implements OnInit {
  submitted = false;
  form: FormGroup;
  loadingname = false;
  isAddMode: boolean;
  uId: string;
  cID: string;
  connactionname: string;
  auid: string;
  Connections = null;
  startname: string;
  countChanged: EventEmitter<number> = new EventEmitter();

  checkonparent = false;
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private connectionservice: ConnectionService


  ) {
  }
  ngOnInit(): void {
    this.uId = this.route.snapshot.params.uid;
    try {
      this.route.firstChild.params.subscribe(params => {
        //let auid = +params['auid'];
        this.auid = params['auid'];
      });
    } catch (e) {

    }

    // this.auid = this.route.snapshot.params.auid;
    ////   this.cID = sessionStorage.getItem('cid')
    //   this.route.parent.params.subscribe(
    //     (params) => {
    //       this.uId = params.uid;
    //     });
    //  // this.uId = this.route.snapshot.params['uid'];
    //   this.auid = this.route.snapshot.params['auid'];
    if (this.auid) {
      this.connectionservice.getAutomation(this.auid)
        .pipe(first())
        .subscribe(
          Connections => {
            this.Connections = Connections,
              this.startname = Connections.automationName,
              this.f.connectionName.setValue(Connections.automationName);

          });
    }


    if (this.auid) {
      this.isAddMode = false;
      this.form = this.formBuilder.group({
        connectionName: ['', Validators.required],
        flag: 'M',
        uId: this.uId,
        cID: this.auid
      });
    } else {
      this.isAddMode = true;
      this.form = this.formBuilder.group({
        connectionName: ['', Validators.required],
        flag: 'N',
        uId: this.uId,
        cID: this.uId
      });
    }

  }
  get f() { return this.form.controls; }


  onSubmit() {
    this.submitted = true;
    // reset alerts on submit
    this.alertService.clear();
    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }
    this.checkonparent = true;
    this.loadingname = true;
    if (this.isAddMode) {
      this.createConnection();
    } else {
      if (this.startname != this.form.get('connectionName').value) {
        this.updateConnection();
      }
    }

  }
  onFocusEvent(e) {
    if (this.form.get('connectionName').value) {
      this.checkonparent = true;
    }

  }
  get formExitValidation() {
    if (this.form.get('connectionName').value) {
      return this.checkonparent = true;
    } else {
      this.onSubmit();
      return this.checkonparent = false;
    }
  }
  private createConnection() {


    this.connectionservice.createconnection(this.form.value)
      .pipe(first())
      .subscribe(
        data => {
          this.loadingname = false;
          if (!data.isSuccess) {
            this.alertService.error(data.message);
          }
          else {
            this.cID = data.message;
            this.connactionname = this.form.get('connectionName').value;
            sessionStorage.setItem('cid', data.message);
            this.checkonparent = true;
            this.ngOnInit();

            this.alertService.success('Automation Name Save successfully', { keepAfterRouteChange: true });
            this.router.navigate(['./connection/New/' + this.uId + '/name/edit/' + data.message]);
          }
        },
        error => {
          this.alertService.error(error);
          this.loadingname = false;
        });
  }

  private updateConnection() {


    this.connectionservice.createconnection(this.form.value)
      .pipe(first())
      .subscribe(
        data => {
          this.loadingname = false;
          if (!data.isSuccess) {
            this.alertService.error(data.message);
          }
          else {
            this.cID = data.message;
            sessionStorage.setItem('cid', data.message);
            this.checkonparent = true;
            this.alertService.success('Automation Updated successfully', { keepAfterRouteChange: true });


          }
        },
        error => {
          this.alertService.error(error);
          this.loadingname = false;
        });
  }

}
